import React from 'react';
import Credits from '../../components/Credits';

const CreditPage = props => {
  return (
    <>
      <Credits />
    </>
  );
};

export default CreditPage;